import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionHeading } from "./SectionHeading";
import { useLang } from "../../i18n/LanguageContext";

const Chapter = ({ text, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "start 0.35"] });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.25, 1]);
  const y = useTransform(scrollYProgress, [0, 1], [24, 0]);
  return (
    <motion.div ref={ref} style={{ opacity, y }} className="flex gap-6 md:gap-10">
      <span className="font-display text-2xl text-gold-light md:text-3xl">0{index + 1}</span>
      <p className="font-display text-2xl font-light leading-snug text-white md:text-4xl lg:text-[2.75rem]">{text}</p>
    </motion.div>
  );
};

export const OurVision = () => {
  const { t } = useLang();
  const s = t.vision;
  return (
    <section id="vision" data-testid="vision-section" className="relative overflow-hidden bg-ink-900 py-24 md:py-36">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[400px] w-[400px] -translate-x-1/2 rounded-full bg-gold-primary/10 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-5xl px-6 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} testid="vision-heading" />
        <div className="mt-16 space-y-12 md:space-y-16">
          {s.chapters.map((c, i) => (
            <Chapter key={i} text={c} index={i} />
          ))}
        </div>
        <div className="divider-gold mt-20" />
      </div>
    </section>
  );
};
